// d88a0b5e33a0fc9e3ecff4452e7a717a9acf33cd|kind=parser-js|name=McpServerInfo|schemaHash=697fb95c74d52a6b823b1fef24e68269c9e32731

import { setDefinedValue } from '@myre/common-primitives';

export function parseMcpServerInfoFromJSON(
  _data,
) {
  if (!_data) {
    return _data;
  }

  const result = {};

  setDefinedValue(result, 'id', _data.id);
  setDefinedValue(result, 'name', _data.name);
  setDefinedValue(result, 'description', _data.description);
  setDefinedValue(result, 'defaultEnabled', _data.defaultEnabled);

  return result;
}

export function parseMcpServerInfoToJSON(
  _data,
) {
  if (!_data) {
    return _data;
  }

  const result = {};

  setDefinedValue(result, 'id', _data.id);
  setDefinedValue(result, 'name', _data.name);
  setDefinedValue(result, 'description', _data.description);
  setDefinedValue(result, 'defaultEnabled', _data.defaultEnabled);

  return result;
}
